import { render, staticRenderFns } from "./PettycashDocument.vue?vue&type=template&id=38659b9a"
import script from "./PettycashDocument.vue?vue&type=script&lang=js"
export * from "./PettycashDocument.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports